<template>
  <div class="common_bg main">
    <p class="title">
      <span>消息</span>
      <span class="edit cursor" @click="editor()" v-if="source.length">{{editStatus?'完成':'编辑'}}</span>
    </p>
    <div class="content" :class="{'bg':!loadErrorShow && !noNetworkShow}">
      <transition-group
        v-if="source.length>0"
        name="list"
        tag="ul"
        mode="out-in"
        id="message_ul"
        @scroll.native="handleScroll('list')"
      >
        <li
          class="cursor"
          @click="goDetail(item.messageId,index)"
          v-for="(item,index) in source"
          v-bind:key="item.messageId"
        >
          <div class="userBox" :class="{'dot':item.status==0}">
            <img class="user_icon" :src="item.avatar || '/static/img/common/defaultTeacherImg.png'" alt />
          </div>
          <div class="right">
            <p class="textblock">
              <span class="teacher">{{item.title}}</span>
              <span class="text">{{item.content&&item.content.substr(0,25)}}</span>
            </p>
            <p class="operate">
              <span class="dateTime">{{item.createTime|formatTime(serverTime)}}</span>
              <transition mode="out-in" name="fade">
                <span v-if="!editStatus" class="arrow"></span>
                <i v-else class="del" @click.stop="del(item.messageId,index)">删除</i>
              </transition>
            </p>
          </div>
        </li>
        <div class="loadingBox"  :class="{'loadingBoxBottom':!hasScroll}" key="loadingBox" v-show="!editStatus">
          <div v-if="loadingType==2 || !hasScroll" class="emptyMsg">- 没有更多消息了 -</div>
          <div v-if="loadingType==1" class="loading-center">
            <div class="loadEffect">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="text">加载中</div>
          </div>
        </div>
      </transition-group>

      <div class="empty" v-if="showEmpty">
        <img src="/static/img/class/myBadge/noBadage.png" alt />
        <span>还没有收到新消息</span>
      </div>
      <loadError @loadAgain="getData()" v-if="loadErrorShow" loadErrorText="消息详情获取失败，请点击按钮重新加载～" />
      <noNetwork v-if="noNetworkShow" />
    </div>
    <Back @goBack="goBack" />
    <Toast v-if="showToast" :showText="'点击右上角的“完成”后，再查看详情吧！'" @toastCallBack="toastClose" />
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import Toast from "@/components/basic/toast.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import toast from "@/components/basic/toast.vue";
import noNetwork from "./noNetwork.vue";
import loadError from "../../basic/loadError";
import common from 'common';

export default {
  data() {
    return {
      editStatus: false,//点击编辑
      showToast: false,
      source: [],//数据集合
      loadingType: 0,
      showEmpty: false,//数据为空
      loadErrorShow: false,//点击重试
      noNetworkShow: false,//无网提示
      hasScroll:false,//是否出现滚动条
      serverTime:0
    };
  },
  components: {
    Back,
    Toast,
    noNetwork,
    loadError
  },
  beforeMount() {
    this.getData(true);
  },
  watch:{
    source(){
      this.hasScrollbar()
    }
  },
  methods: {
    ...mapActions(["getMsgList", "delMessage"]),
    hasScrollbar(){
      setTimeout(()=>{
        let ulDom = document.getElementById('message_ul');
        let ul_h = ulDom?ulDom.offsetHeight:80;//外层盒子高度
        let content_h = (108*this.source.length)+80;//内容高度
        if(ul_h>=content_h){
          this.hasScroll = false;
        }else{
          this.hasScroll = true;
        }
      },0)
    },
    editor(){
      this.editStatus=!this.editStatus;
      if(!this.hasScroll && !this.editStatus && !this.showEmpty){
        this.getData();
      }
    },
    toastClose() {
      this.showToast = false;
    },
    goDetail(id, index) {
      if (this.editStatus) {
        this.showToast = true;
        return;
      }
      this.$router.push({
        path: "/msgdetail",
        query: {
          id
        }
      });
      this.$root.eventHub.$emit("createLog", {
        id:'LMTrackEventMesssageView',
        data:{
          source:1
        }
      });
    },
    goBack() {
      this.$router.push("/class");
    },
    del(id, index) {
      this.delMessage({ id }).then(({ res, ok }) => {
        if (ok) {
          this.source.splice(index, 1);
        }
      });
    },
    handleScroll() {
      let target = document.getElementById('message_ul');
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = target.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = target.scrollHeight;
      if (scrollTop + windowHeight >= scrollHeight) {
        // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
        if (this.editStatus) return;
        if ( this.loadingType == 2) return;
        this.loadingType = 1;
        this.getData();
      }
    },
    getData(needLoading=false) {
      this.loadErrorShow = false;
      this.noNetworkShow = !navigator.onLine;
      if (this.noNetworkShow) return;
      let lastId = this.source.length ? this.source[this.source.length-1].messageId : 0;
      this.getMsgList({
        data: {
          lastId,
          client:common.client
        },
        config: {
          needLoading
        }
      }).then(({ res, ok }) => {
          if (ok) {
            if(res){
              this.source.push(...res);
              this.serverTime = common.getTemServerTime();
            }
            this.loadingType = !res || res.length === 0?2:0;
          }
          if (this.source.length===0 && !res || this.source.length===0 && res.length === 0) this.showEmpty = true;
        })
        .catch(e => {
          this.loadErrorShow = true;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@bg-color: #0089ce;
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.2s ease;
}

.list-leave-to {
  opacity: 0;
  transform: translateY(-90px);
}
.list-leave-active,
.list-enter-active {
  transition: all 0.5s ease;
}
.list-move {
  transition: all 0.5s ease;
}
.list-leave-active {
  position: absolute;
  width: 1018px;
}
.main {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 60px;
  .menu {
    position: fixed;
  }
  .title {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: @bg-color;
    font-size: 26px;
    color: #fff;
    position: relative;
    margin-bottom: 15px;
    position: relative;
    .edit {
      position: absolute;
      right: 40px;
      font-size: 20px;
    }
  }
  .bg {
    background: #f1f3f4;
  }
  .content {
    display: flex;
    flex-direction: column;
    width: 1024px;
    height: 100%;
    margin: 0 40px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 15px;
    position: relative;
    overflow:hidden;
    ul {
      position: relative;
      transition: height 2s;
      height: 100%;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 6px;
        box-shadow: inset 0 0 5px #d7d7d7;
        background: #d7d7d7;
        //   -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        background: #f1f3f4;
        // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      }
      li {
        padding: 10px 30px 0 30px;
        height: 108px;
        text-align: left;
        display: flex;
        align-items: center;
        &:hover {
          background: #ebedee;
        }
        .userBox {
          min-height: 64px;
          min-width: 64px;
          border: 1px solid #c0d1d6;
          border-radius: 50%;
          font-size: 0;
          position: relative;
          margin-right: 20px;
        }
        .user_icon {
          height: 64px;
          width: 64px;
          border-radius: 50%;
          border: 1px solid #c0d1d6;

          vertical-align: middle;
        }
        .dot {
          vertical-align: bottom;
          position: relative;
          &::after {
            content: "";
            height: 12px;
            width: 12px;
            display: inline-block;
            position: absolute;
            top: 1px;
            right: 1px;
            border-radius: 50%;
            background: red;
          }
        }
        .right {
          border-bottom: 1px solid #e4e4e4;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .textblock {
            span {
              display: block;
              height: 32px;
              line-height: 32px;
              color: #666;
              font-size: 18px;
            }
            .teacher {
              color: #333;
              font-weight: 700;
              font-size: 21px;
              overflow: hidden;
              padding-right: 80px;
            }
            .text {
              white-space: pre-wrap;
              overflow: hidden;
              padding-top: 3px;
            }
          }
          .operate {
            display: flex;
            height: 100%;
            min-width: 75px;
            justify-content: center;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-end;
            .dateTime {
              height: 32px;
              line-height: 32px;
              color: #b3b3b3;

              font-size: 16px;
              align-self: flex-start;
            }
            .arrow {
              width: 70px;
              height: 32px;
              background: url(../../../assets/img/common/arrow_gray.png)
                no-repeat right center;
              background-size: 10px;
              margin-top: -26px;
            }
            .del {
              width: 70px;
              height: 32px;
              line-height: 31px;
              color: #c73939;
              border: 1px solid #c73939;
              text-align: center;
              border-radius: 6px;
              font-size: 16px;
              margin-top: -18px;
            }
          }
        }
      }
    }
    .empty {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 408px;
        height: 170px;
        margin-bottom: 30px;
      }
      span {
        color: #c0c0c0;
        font-size: 20px;
      }
    }
    .loadingBoxBottom{
      position: absolute;
      bottom: 0;
    }
    .loadingBox {
      width: 100%;
      height: 80px;
      min-height: 80px;
      background: #f1f3f4;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: none !important;
      // background-image: linear-gradient(to bottom, rgba(255,255,255,0.5), rgba(255,255,255,1));
      border-radius: 0 0 20px 20px;
      .emptyMsg {
        color: #d8d8d8;
        font-size: 22px;
        padding-top: 20px;
      }
      .loading-center {
        display: flex;
        width: 200px;
        height: 80px;
        .loadEffect {
          width: 10px;
          height: 100px;
          position: relative;
          transform: scale(0.4);
          transform-origin: center right;
          text-align: center;
          top: -12px;
          flex: 0 0 100px;
        }

        .loadEffect span {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #007a9c;
          position: absolute;
          animation: load 1.04s ease infinite;
        }
        @keyframes load {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.2;
          }
        }
        .loadEffect span:nth-child(1) {
          left: 0;
          top: 50%;
          margin-top: -8px;
          animation-delay: 0.13s;
        }
        .loadEffect span:nth-child(2) {
          left: 14px;
          top: 14px;
          animation-delay: 0.26s;
        }
        .loadEffect span:nth-child(3) {
          left: 50%;
          top: 0;
          margin-left: -8px;
          animation-delay: 0.39s;
        }
        .loadEffect span:nth-child(4) {
          top: 14px;
          right: 14px;
          animation-delay: 0.52s;
        }
        .loadEffect span:nth-child(5) {
          right: 0;
          top: 50%;
          margin-top: -8px;
          animation-delay: 0.65s;
        }
        .loadEffect span:nth-child(6) {
          right: 14px;
          bottom: 14px;
          animation-delay: 0.78s;
        }
        .loadEffect span:nth-child(7) {
          bottom: 0;
          left: 50%;
          margin-left: -8px;
          animation-delay: 0.91s;
        }
        .loadEffect span:nth-child(8) {
          bottom: 14px;
          left: 14px;
          animation-delay: 1.04s;
        }
        .text {
          color: #0073ae;
          line-height: 76px;
          font-size: 21px;
          margin-left: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/message/messageList.vue